import React from "react";
import { Tabs } from "antd";
import { t } from "i18next";

import type { TabsProps } from "antd";

import style from "./ExciseWarehouseRequestLicence.module.scss";
import { RequestHistoryTable } from "./components/RequestHistoryTable/RequestHistoryTable";
import { RescriptHistoryTable } from "./components/RescriptHistoryTable/RescriptHistoryTable";
import { ExciseLicencesRequestForm } from "../../ExciseLicences/ExciseLicencesRequestForm/ExciseLicencesRequestForm";
import { GoBackButton } from "../../../../components/GoBackButton/GoBackButton";

export const ExciseWarehouseRequestLicence = () => {
  const tabs: TabsProps["items"] = [
    {
      key: "1",
      label: t("SKLADISTA.PREGLED_VAZECEG_ZAHTEVA_SKLADISTA"),
      children: <ExciseLicencesRequestForm type="skladista" />,
    },
    {
      key: "2",
      label: t("SKLADISTA.ISTORIJA_ZAHTEVA"),
      children: <RequestHistoryTable />,
    },
    {
      key: "3",
      label: t("SKLADISTA.ISTORIJA_RESENJA"),
      children: <RescriptHistoryTable />,
    },
  ];

  const routePath = "/obveznik/skladista/listaSkladista";

  return (
    <div className={style.mainContainer}>
      <GoBackButton routePath={routePath} />
      <Tabs defaultActiveKey="1" items={tabs} />
    </div>
  );
};
